import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex py-2 items-center" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "font-medium text-left" }
const _hoisted_4 = { class: "flex-grow text-right h-6" }
const _hoisted_5 = { class: "my-1 ml-3" }

import { onMounted, ref, watch } from 'vue';
import BaseCheckbox from '@/lib/components/Checkbox/BaseCheckbox.vue';
import BaseIcon from '@/lib/components/Icon/BaseIcon.vue';
import NumberBadge from '@/lib/components/Badge/NumberBadge.vue';
import { ICheckboxOption, IPopoverOption } from '@/lib';
import { useI18n } from 'vue-i18n';
import BaseButton from '@/lib/components/Button/BaseButton.vue';
import { v4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopoverAccordion',
  props: {
    heading: null,
    options: null,
    clearTrigger: null,
    preSelectedOptions: null
  },
  emits: ["updateSelectedValues"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateSelectedValues', selectedValues: Array<ICheckboxOption>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  heading: string;
  options: Array<IPopoverOption>;
  clearTrigger: number;
  preSelectedOptions?: Array<ICheckboxOption>;
};





const isExpanded = ref(true);
const selectedValues = ref<Array<ICheckboxOption>>([]);
const baseCheckboxModelValue = ref<Array<string>>([]);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { t } = useI18n();
const listId = `list-${v4()}`;

watch(() => props.clearTrigger, () => {
  handleClearAll();
});

onMounted(() => {
  if (props?.preSelectedOptions?.length > 0) {
    baseCheckboxModelValue.value = (props.preSelectedOptions.map((option) => option.id));
    selectedValues.value = props.preSelectedOptions ? props.preSelectedOptions : [];
  }
});

const toggleIsExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

const handleClearAll = () => {
  selectedValues.value = [];
  baseCheckboxModelValue.value = [];
  emit('updateSelectedValues', selectedValues.value);
};

const handleClear = () => {
  selectedValues.value = [];
  baseCheckboxModelValue.value = [];
  emit('updateSelectedValues', selectedValues.value);
};

const handleUpdateListObject = (value: ICheckboxOption) => {
  if (value.checked) {
    selectedValues.value.push(value);
  } else {
    selectedValues.value = selectedValues.value.filter(
      (it) => it.id !== value.id
    );
  }
  emit('updateSelectedValues', selectedValues.value);
};

return (_ctx: any,_cache: any) => {
  const _component_MkBadge = _resolveComponent("MkBadge")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        "aria-controls": listId,
        "aria-expanded": isExpanded.value,
        class: "btn-focus-visible-outline flex items-center",
        "data-dusk": "heading-btn",
        onClick: toggleIsExpanded
      }, [
        _createVNode(BaseIcon, {
          class: _normalizeClass([{ 'transform rotate-90': isExpanded.value }, "stroke-1.5 transition-transform duration-300 ease-in-out ml-1 flex-shrink-0 self-start mt-1"]),
          name: "chevron-right",
          position: "left"
        }, null, 8, ["class"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.heading), 1),
        (selectedValues.value.length > 0)
          ? (_openBlock(), _createBlock(NumberBadge, {
              key: 0,
              "badge-number": selectedValues.value.length,
              class: "ml-2 mr-1"
            }, null, 8, ["badge-number"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(BaseButton, {
          class: "px-3",
          color: "ghost",
          "data-dusk": "clear-btn",
          size: "sm",
          onClick: handleClear
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('platform.common.clear')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, selectedValues.value.length > 0]
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("ul", {
      id: listId,
      "data-dusk": "accordion-list"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: option.id,
          class: "w-full flex flex-col"
        }, [
          _createVNode(BaseCheckbox, {
            modelValue: baseCheckboxModelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseCheckboxModelValue).value = $event)),
            border: false,
            "data-dusk": `popover-checkbox-${index}`,
            label: option.name,
            shadow: false,
            value: option.id,
            "checkbox-class": "ml-1 h-4 w-4",
            "text-class": "py-2 leading-5",
            "onUpdate:listObject": handleUpdateListObject
          }, _createSlots({ _: 2 }, [
            (option.color)
              ? {
                  name: "customLabel",
                  fn: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, [
                      (option.color)
                        ? (_openBlock(), _createBlock(_component_MkBadge, {
                            key: 0,
                            color: option.color,
                            rounded: true,
                            size: "xsmall"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "data-dusk", "label", "value"])
        ]))
      }), 128))
    ], 512), [
      [_vShow, isExpanded.value]
    ])
  ]))
}
}

})